import * as React from 'react'
import { withTranslation } from 'react-i18next'
import { compose } from 'redux'
import { connect } from 'react-redux'
import SVG from 'react-inlinesvg'
import { Link } from 'react-router-dom'
import logoBliinkSvg from '@App/assets/logo-bliink.svg'
import { HOMEPAGE_ROUTE } from '@App/constantes'
import UserInformation from '@App/components/blocks/UserInformation'
import FormatText from '@App/helpers/formatText'
import { userCanAccessMenu } from '@App/helpers/user'
import menu, { IRoutes } from '@App/configs/menu'
import './styles.scss'
import { AppState } from 'reducers'
import { Props } from './types'

class Menu extends React.Component<Props> {
  static isActive(currentPath: IRoutes, item: IRoutes) {
    return currentPath && item && currentPath.path === item.path ? 'isActive' : ''
  }

  renderMenu(menu: IRoutes[]) {
    const {
      currentPath,
      currentApp,
      user,
      t,
    } = this.props

    return menu.map((item) => {
      if (!userCanAccessMenu(item, user, currentApp)) {
        return
      }

      return (
        <li
          key={item.path}
        >
          <Link
            to={item && item.path}
            className={`sidebar-nav__link ${Menu.isActive(currentPath, item)}`}
          >
            <div
              className="sidebar-nav__link__icon"
              key={item.icon}
            >
              <SVG src={FormatText.formatSVGBase64(item.icon)} />
            </div>
            <p className="sidebar-nav__link__label">
              {item && t(item.title)}
            </p>
          </Link>
        </li>
      )
    })
  }

  render() {
    return (
      <aside className="sidebar">
        <span className="sidebar-logo">
          <Link to={HOMEPAGE_ROUTE}>
            <SVG src={logoBliinkSvg} />
          </Link>
          <UserInformation />
        </span>
        <nav className="sidebar-nav">
          <ul>
            {this.renderMenu(menu)}
          </ul>
        </nav>
      </aside>
    )
  }
}

const mapStateToProps = (state: AppState) => {
  const {
    user: {
      user,
      currentApp,
    },
  } = state

  return {
    user,
    currentApp,
  }
}

export default compose<any>(
  withTranslation(),
  connect(mapStateToProps, null),
)(Menu)
